var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoins(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 18,
    cy: 5.1,
    rx: 18,
    ry: 5.1,
    transform: "translate(26 2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26,14.9c0,2.8,8.1,5.1,18,5.1s18-2.3,18-5.1m-36,8c0,2.8,8.1,5.1,18,5.1s18-2.3,18-5.1m-36,8c0,2.8,8.1,5.1,18,5.1s18-2.3,18-5.1M38,43.7a57.364,57.364,0,0,0,6,.3c9.9,0,18-2.3,18-5.1M26,36.1V7.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M62,7.1V46.9c0,2.8-8.1,5.1-18,5.1a57.364,57.364,0,0,1-6-.3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 18,
    cy: 5.1,
    rx: 18,
    ry: 5.1,
    transform: "translate(2 35.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2,48.9C2,51.7,10,54,20,54s18-2.3,18-5.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M38,40.9v16c0,2.8-8.1,5.1-18,5.1S2,59.7,2,56.9V41.3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.9025b158971311155f9d20ac835dcd32.svg";
export { ForwardRef as ReactComponent };